import React, { FC } from "react";

import { Stack } from "react-bootstrap";

import { RequestSource } from "@api/graphql";
import { FileDisplay } from "@components/grouped_resales/FileDisplay";
import { SubmissionInfo } from "@components/grouped_resales/SubmissionInfo";

interface DocumentSubmissionInfoProps {
  batchDocS3Location?: string;
  resaleCount: number;
  reportedOn?: string;
  requestSource?: string;
}

export const DocumentSubmissionInfo: FC<DocumentSubmissionInfoProps> = ({
  batchDocS3Location,
  resaleCount,
  reportedOn,
  requestSource,
}) => (
  <Stack>
    {batchDocS3Location ? (
      <FileDisplay s3_location={batchDocS3Location} />
    ) : requestSource === RequestSource.EXTERNAL_USER_SPREADSHEET ? (
      <div className="b3 mb-1">Offline submission</div>
    ) : (
      <div className="b3 mb-1">Web Form Submission</div>
    )}
    <SubmissionInfo resaleCount={resaleCount} date={reportedOn} />
  </Stack>
);
